import "./AddFunctionality.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import AddFunctionalityComponentController from "./AddFunctionalityComponentController";

export default class AddFunctionalityComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddFunctionalityComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning" +
            "/SelectedEquipment/MapConfigurations/AddFunctionality/AddFunctionality.html";
    }
}

module("mmManagePortal").component("mmAddFunctionality", new AddFunctionalityComponent());
